import React from "react";

export const Tablist = ({ currentTab, children, index, childClassName }) => {
  return currentTab === index ? (
    <div className={`${childClassName}`}>{children}</div>
  ) : null;
};

export const Tabs = (props) => {
  const {
    tabs,
    currentTab,
    onChangeTab,
    children,
    isFirstLong,
    tabWidth,
    titleTabPosition = "justify-center",
    isDisabled = false,
    marginTop = "mt-[32px]",
  } = props;
  return (
    <div>
      <div className="mt-4 w-full border-b-2 border-black">
        <ul className="flex overflow-auto no-scrollbar">
          {tabs?.map((val) => {
            return (
              <li
                key={val?.id}
                className={`${
                  val?.totalData ? "" : "flex justify-center"
                } cursor-pointer py-2 px-2 rounded-t-lg text-center ${
                  currentTab === val.id
                    ? "bg-primary-blue text-white font-bold"
                    : "bg-white border border-[#ddd] text-[#aaaaaa]"
                } w-45`}
                onClick={isDisabled ? null : () => onChangeTab(val.id)}
              >
                <div
                  className={`flex ${tabWidth} ${
                    isFirstLong ? (val?.id - 1 ? "px-4" : "px-10") : ""
                  } ${titleTabPosition} items-center`}
                >
                  <span>{val?.title}</span>
                  {val?.totalData ? (
                    <span
                      className={`font-bold ${
                        currentTab === val?.id ? "text-white" : "text-black"
                      }`}
                    >
                      {val?.totalData}
                    </span>
                  ) : null}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
      <div className={`${marginTop}`}>{children}</div>
    </div>
  );
};

export default Tabs;
